import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const rows = [{
  label: 'Planificación de sesiones',
  without: 'Improvisás cada entrenamiento',
  with: 'Plan anual y semanas listas para usar'
}, {
  label: 'Errores técnicos',
  without: 'Se repiten temporada tras temporada',
  with: 'Detectás y corregís paso a paso'
}, {
  label: 'Progresión por edad',
  without: 'No sabés qué exigir en cada etapa',
  with: 'Ruta clara de infantil a adulto'
}, {
  label: 'Análisis de partidos',
  without: 'Decidís a ojo',
  with: 'Scouting y estadísticas en Excel'
}, {
  label: 'Gestión del equipo y padres',
  without: 'Conflictos y malos entendidos',
  with: 'Guía de comunicación + mensajes tipo'
}];
export function Comparison() {
  return <section className="w-full bg-white py-12 md:py-16 px-4" data-id="element-23">
      <div className="max-w-4xl mx-auto" data-id="element-24">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-8" data-id="element-25">
          Con vs Sin el Sistema para Entrenadores
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="grid grid-cols-2 rounded-xl overflow-hidden border-2 border-gray-200 shadow-md text-sm md:text-base" data-id="element-26">
          {/* Headers */}
          <div className="bg-gray-200 text-gray-700 font-bold text-center py-3 px-3" data-id="element-27">
            Sin sistema
          </div>
          <div className="bg-blue-600 text-white font-bold text-center py-3 px-3" data-id="element-28">
            Con el sistema
          </div>

          {/* Rows */}
          {rows.map((row, index) => <Fragment key={index} data-id="element-29">
              <div className={`flex items-start gap-2 px-3 py-3 ${index % 2 === 0 ? 'bg-red-50' : 'bg-red-50/60'}`} data-id="element-30">
                <XIcon className="w-4 h-4 text-red-500 flex-shrink-0 mt-0.5" data-id="element-31" />
                <span className="text-gray-700" data-id="element-32">{row.without}</span>
              </div>
              <div className={`flex items-start gap-2 px-3 py-3 ${index % 2 === 0 ? 'bg-orange-50' : 'bg-orange-50/60'}`} data-id="element-33">
                <CheckIcon className="w-4 h-4 text-green-600 flex-shrink-0 mt-0.5" data-id="element-34" />
                <span className="text-gray-800 font-medium" data-id="element-35">{row.with}</span>
              </div>
            </Fragment>)}
        </motion.div>
      </div>
    </section>;
}